var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2959_977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5C7.21997 18.5 5.47991 17.9722 3.99987 16.9832C2.51983 15.9943 1.36628 14.5887 0.685088 12.9442C0.00389957 11.2996 -0.17433 9.49002 0.172937 7.74419C0.520204 5.99836 1.37737 4.39472 2.63604 3.13604C3.89472 1.87737 5.49836 1.0202 7.24419 0.672937C8.99002 0.32567 10.7996 0.5039 12.4442 1.18509C14.0887 1.86628 15.4943 3.01983 16.4832 4.49987C17.4722 5.97991 18 7.71997 18 9.5C17.9974 11.8862 17.0484 14.1738 15.3611 15.8611C13.6738 17.5484 11.3862 18.4974 9 18.5V18.5ZM9 2C7.51664 2 6.0666 2.43987 4.83323 3.26398C3.59986 4.08809 2.63856 5.25943 2.07091 6.62988C1.50325 8.00032 1.35473 9.50832 1.64411 10.9632C1.9335 12.418 2.64781 13.7544 3.6967 14.8033C4.7456 15.8522 6.08197 16.5665 7.53683 16.8559C8.99168 17.1453 10.4997 16.9968 11.8701 16.4291C13.2406 15.8614 14.4119 14.9001 15.236 13.6668C16.0601 12.4334 16.5 10.9834 16.5 9.5C16.4978 7.51155 15.7069 5.60516 14.3009 4.19911C12.8948 2.79307 10.9885 2.00219 9 2V2Z",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9603 12.1985L5.16455 10.9265L8.25005 8.99375V5H9.75005V9.82475L5.9603 12.1985Z",
    fill: "#171926"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2959_977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
export default SvgClock;